import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import { StatusBadge } from "./Badge";
import { CodeBlock } from "./CodeBlock";

interface ResponseExampleProps {
  status: number;
  description: string;
  body: string;
}

export function ResponseExample({
  status,
  description,
  body,
}: ResponseExampleProps) {
  const [open, setOpen] = useState(false);

  let formattedBody = body;
  try {
    formattedBody = JSON.stringify(JSON.parse(body), null, 2);
  } catch {
    // keep as-is if not valid JSON
  }

  return (
    <div className="border border-base-content/10 rounded-lg overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-base-200/50 transition-colors"
      >
        {open ? (
          <ChevronDown className="w-3.5 h-3.5 text-base-content/40 shrink-0" />
        ) : (
          <ChevronRight className="w-3.5 h-3.5 text-base-content/40 shrink-0" />
        )}
        <StatusBadge code={status} />
        <span className="text-xs text-base-content/70">{description}</span>
      </button>
      {open && (
        <div className="px-3 pb-3">
          <CodeBlock code={formattedBody} language="json" />
        </div>
      )}
    </div>
  );
}
